import { useFormik } from "formik";
import { programacionInitialValues } from "../constants/constants";
import { ProgramacionForm } from "./programacion.form";
import { useProgramacion } from "../hooks/useProgramacion";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { programacionValidationSchema } from "../constants/validations";

const initialValues = programacionInitialValues;
const validationSchema = programacionValidationSchema;

export const AddProgramacion = ({ onSave, onCanel, fecha }) => {
  const { postProgramacion } = useProgramacion();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    try {
      setIsLoading(true);
      await postProgramacion(values);
      setIsLoading(false);
      Swal.fire({
        icon: "success",
        title: "Programación guardada",
        timer: 1500,
      });
      onSave();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Algo salio mal!",
        text: `Favor de comunicarlo con el equipo de desarrollo: ${error}`,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const { values, errors, touched, setFieldValue, handleSubmit, handleChange } =
    useFormik({
      onSubmit,
      initialValues,
      validationSchema,
    });

  useEffect(() => {
    setFieldValue("fecha", fecha);
  }, [fecha, setFieldValue]);
  return (
    <ProgramacionForm
      values={values}
      errors={errors}
      touched={touched}
      setFieldValue={setFieldValue}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      isLoading={isLoading}
      onCancel={onCanel}
    />
  );
};
